module.exports = __webpack_public_path__ + "img/plats.1f7d76ba.svg";